// extracted by mini-css-extract-plugin
module.exports = {"full_height":"Spinner__full_height___2zYUn","fixed_height":"Spinner__fixed_height___2x9R4"};